import {
  STUDENT_DASHBOARD_ROOT_URL,
  STUDENT_DASHBOARD_ROUTES,
} from '@common/constants'
import { Icon } from '@components/common/icons'
import {
  Certificate,
  Puzzle,
  Trophy,
} from '@components/common/icons/custom-icons'
import Link from 'next/link'

const PaidStudentNavbarLinks = () => {
  const customIcons = ['Quiz', 'Certificate', 'Trophy']
  const updatedDashboardRoutes = [...STUDENT_DASHBOARD_ROUTES]
  return (
    <>
      {updatedDashboardRoutes.map((item) => (
        <Link href={`${STUDENT_DASHBOARD_ROOT_URL}${item.url}`} key={item.url}>
          <a
            className="mt-3 text-xl text-grey font-500 flex items-center space-x-5"
            rel="noopener noreferrer"
          >
            {item.icon === 'Quiz' && (
              <Puzzle className="h-5 w-5 text-grey-800 inline-block" />
            )}
            {item.icon === 'Certificate' && (
              <Certificate className="h-5 w-5 text-grey-800 inline-block" />
            )}
            {item.icon === 'Trophy' && (
              <Trophy className="h-5 w-5 text-grey-800 inline-block" />
            )}
            {!customIcons.includes(item.icon) && (
              <Icon
                name={item.icon}
                className="h-5 w-5 text-grey-800 inline-block"
              />
            )}
            <p>{item.title}</p>
          </a>
        </Link>
      ))}
    </>
  )
}

export default PaidStudentNavbarLinks
